export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert, DirectoriesResource) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
        this.$tenantParameters = angular.copy(this.tenantParameters);
    }

    saveTenantParameters() {
        this.isSaving = true;
        this.DirectoriesResource.updateAzureTenantParameters(
            this.companyId,
            this.directoryId,
            this.tenantParameters
        )
        .then(() => {
            this.$tenantParameters = angular.copy(this.tenantParameters);
            this.Alert('success', 'company.directory-integration.manage.connection-azure.tenant-parameters.updated');
        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        })
        .finally(() => this.isSaving = false);
    }

    testConnectionEnabled() {
        let tenPrms = this.$tenantParameters;
        return tenPrms.tenantId && tenPrms.clientId && tenPrms.clientSecret;
    }

    testConnection() {
        this.isTestingConnection = true;
        this.DirectoriesResource.testAzureConnection(
            this.companyId,
            this.directoryId
        )
        .then((data) => {
            this.Alert('success', 'company.directory-integration.manage.connection-azure.test-connection.success');
        })
        .catch((error) => {
            this.Alert('danger', 'company.directory-integration.manage.connection-azure.test-connection.failed');
        })
        .finally(() => this.isTestingConnection = false);
    }

    tenantParametersIsNotModified() {
        return angular.equals(this.$tenantParameters, this.tenantParameters);
    }

    resetTenantParameters() {
        this.tenantParameters = angular.copy(this.$tenantParameters);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection-azure/directory-manage-connection-azure.controller.js